import React from 'react'
import { ReactFC } from 'common/types/ReactFC'
import Strings from 'project/localisation'
import OneTwoThreeCard from './base/OneTwoThreeCard'
import { mailroomStrings } from 'common/strings/mailroom-strings'

type MailroomSetupCardType = {}

const MailroomSetupCard: ReactFC<MailroomSetupCardType> = ({}) => {
  return (
    <div className={'mt-lg-25 mt-6 mb-lg-25 mb-4 mx-xs-0 mx-2'}>
      <OneTwoThreeCard
        headingClasses={'mx-xs-0 mx-n2'}
        imagesOption={5}
        color={'gradient-red2'}
        title={`${Strings.gettingYouSetup}`}
        content={[
          {
            content: `${mailroomStrings.weGetYourMailDescription}`,
            image: require('public/images/steps/step-1.png'),
            title: `${mailroomStrings.weGetYourMail}`,
          },
          {
            content: `${mailroomStrings.weScanAndDigitiseDescription}`,
            image: require('public/images/steps/step-2.png'),
            title: `${mailroomStrings.weScanAndDigitise}`,
          },
          {
            content: `${mailroomStrings.weDeliverDescription}`,
            image: require('public/images/steps/scan-pro-page-we-deliver-desktop.png'),
            title: `${mailroomStrings.weDeliver}`,
          },
        ]}
      />
    </div>
  )
}

export default MailroomSetupCard
